import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contactListData: [],
  orgDetailData: null,
};

const contact = createSlice({
  name: "contact",
  initialState,
  reducers: {
    setContactListData: (state, action) => {
      state.contactListData = action.payload;
    },
    setOrgDetailData: (state, action) => {
      state.orgDetailData = action.payload;
    },
    clearContactData: (state) => {
      state.contactListData = [];
      state.orgDetailData = null;
    },
  },
});

export const { setContactListData, setOrgDetailData, clearContactData } =
  contact.actions;

export default contact.reducer;